import { MeResponse } from '../types';
import { CHECKIN_SERVICE_ORIGIN, SHORTY_SERVICE_ORIGIN } from '../config/env';

export const getProjectRedirectUrl = (
  user: MeResponse | null,
  fallbackUrl: string,
  projectCode?: string
): string => {
  if (!user) return fallbackUrl;
  if (user.approvalStatus === 'PENDING') return '/pending-approval';
  if (user.globalRole === 'ROOT_ADMIN') return fallbackUrl;

  const serviceCodes = user.services?.map((service) => service.code) || [];
  const preferredServiceCode = projectCode || serviceCodes.find((code) => code === 'short' || code === 'checkin');
  if (!preferredServiceCode) return fallbackUrl;

  if (preferredServiceCode === 'short') return SHORTY_SERVICE_ORIGIN;
  if (preferredServiceCode === 'checkin') return CHECKIN_SERVICE_ORIGIN;

  return fallbackUrl;
};
